
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TermsAndConditionsWikihow extends Vue {
  data () {
    return {
      isLoading: false,
      today: new Date(),
      lastUpdate: new Date('12-11-2025')
    }
  }
}
